import { DialogTitle } from '@mui/material';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const StyledDialogTitle = styled(DialogTitle)`
  background-color: ${COLORS.PRIMARY};
  color: white;
`;
